<template>
  <v-dialog
    v-model="show"
    max-width="500"
  >
    <v-card>
      <v-card-title>
        <span class="text-h5">{{ state === 2 ? 'Заблокировать карту' : 'Разблокировать карту' }}</span>
      </v-card-title>
      <v-card-text>
        <div class="text-body-2 mb-2">
          Субъект: {{ item ? item.subject_ref : '' }}
        </div>
        <v-list dense>
          <v-list-item
            v-for="c in candidates"
            :key="c.credential_id"
            :disabled="loading"
            @click="apply(c)"
          >
            <v-list-item-content>
              <v-list-item-title>{{ c.uid }} · {{ c.kind_text }}</v-list-item-title>
              <v-list-item-subtitle>{{ c.issuer_text }}</v-list-item-subtitle>
            </v-list-item-content>
          </v-list-item>
        </v-list>
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn
          color="secondary darken-1"
          outlined
          rounded
          small
          class="ml-2 mb-2"
          @click="show = false"
        >
          <span class="mx-4">Отмена</span>
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { SkudCardService } from '@/views/skud/shared/services/skud-card-service'

export default {
  name: 'SkudCardStateDialog',
  data () {
    return {
      svc: null,
      show: false,
      loading: false,
      item: null,
      state: 2
    }
  },
  computed: {
    // Блокировать можно активные, разблокировать — заблокированные.
    candidates () {
      const want = this.state === 2 ? 0 : 2
      return ((this.item && this.item.cards) || []).filter(c => Number(c.state) === want)
    }
  },
  mounted () {
    this.svc = new SkudCardService()
  },
  methods: {
    open (item, state) {
      this.item = item
      this.state = state
      this.show = true
    },
    async apply (c) {
      this.loading = true
      const res = await this.svc.setCredentialState(this.item.place_id, c.credential_id, this.state)
      this.loading = false
      if (res.ok) {
        this.$store.commit('snackbar', 'Карта ' + c.uid + (this.state === 2 ? ' заблокирована' : ' разблокирована') + ', rev ' + res.data.revision)
        this.$emit('done')
        this.show = false
      } else {
        this.$store.commit('snackbar', res.error)
      }
    }
  }
}
</script>
